import React, { useState, useEffect } from "react";
import api from "../../../../Axios/api";
import {
  Paper,
  Button,
  TextField,
  Container,
  Grid,
  Avatar,
  Modal,
} from "@material-ui/core";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { useUserContext } from "../../../../context/UserContext";
import { Redirect } from "react-router-dom";
import ImageCrop from "../../../FormDialog/ImageCrop";
import RemoveStoreLogo from "../../../FormDialog/RemoveStoreLogo";
import useStyles from "./styles";

export default function DashboardCustomization() {
  const classes = useStyles();
  const { store } = useUserContext();
  const token = store.data.token;

  ///Get Dashboard Logo///////////////
  const retrivingDashboardLogo = async () => {
    await api
      .get("/superAdmin/adminPanel/logo", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log(res.data.data.logo);
        setAdminData({ ...adminData, logo: res.data.data.logo });
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  useEffect(() => {
    retrivingDashboardLogo();
  }, []);
  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  const [adminData, setAdminData] = useState({
    logo: "",
  });
  const [isLoggedOut] = useState(false);
  const [isAdminLogoRemove, setAdminLogoRemove] = useState(false);

  const onSelectlogo = (image) => {
    setAdminData({ ...adminData, logo: image });
  };
  const handleChange = (input) => (e) => {
    setAdminData({ ...adminData, [input]: e.target.value });
  };
  // Show delete ProfilePic dialog
  const handlerRemoveAdminLogo = (e) => {
    e.preventDefault();
    setAdminLogoRemove(true);
  };

  // UPDATE REQUEST SENDING HERE
  const handleSubmitUpdate = () => {
    api
      .post(
        "/superAdmin/adminPanel/logo",
        {
          ...adminData,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "Your Store has been updated!",
          open: true,
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) =>
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message:
            "ERROR: " + JSON.stringify(error.response.data.error.message),
          open: true,
        })
      );
  };

  // Modal Settings here
  const [modalOpen, setModelOpen] = useState(false);

  const handleOpen = () => {
    setModelOpen(true);
  };

  const handleClose = () => {
    setModelOpen(false);
  };

  // Show delete ProfilePic dialog
  const handlerRemoveStoreLogo = (e) => {
    e.preventDefault();
    setAdminLogoRemove(true);
  };

  const confirmedRemoveAdminLogo = () => {
    setAdminData({ ...adminData, logo: null });
    setAdminLogoRemove(false);
  };

  return (
    <Grid container className={classes.root}>
      {isLoggedOut ? <Redirect to="/vendor/login" /> : ""}
      <Grid item xs={12} sm={12} md={12} component={Paper}>
        <Container component="div" maxWidth="sm">
          <div className={classes.paper}>
            <Grid className={classes.settingsSpacing}>
              <form className={classes.form}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <Avatar
                    alt="profile photo"
                    src={adminData.logo}
                    className={classes.avatarInProfileSetting}
                  >
                    {"LOGO HERE"}
                  </Avatar>
                  <div style={{ marginTop: 50 }}>
                    <Button
                      style={{ marginLeft: 10 }}
                      variant="contained"
                      color="primary"
                      onClick={handleOpen}
                    >
                      <AddAPhotoIcon
                        style={{
                          marginRight: 5,
                          fontSize: 22,
                          marginBottom: 5,
                        }}
                      />
                      Upload
                    </Button>
                    <Button
                      style={{ color: "red" }}
                      color="red"
                      // variant="contained"
                      onClick={handlerRemoveAdminLogo}
                    >
                      Remove Image
                    </Button>
                  </div>
                </div>

                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={handleSubmitUpdate}
                >
                  SAVE CHANGES
                </Button>
              </form>
            </Grid>
          </div>
          <RemoveStoreLogo
            RemoveStoreLogo={isAdminLogoRemove}
            setAdminLogoRemove={setAdminLogoRemove}
            confirmedRemoveAdminLogo={confirmedRemoveAdminLogo}
          />
          <Snackbar
            open={open}
            anchorOrigin={{ vertical, horizontal }}
            autoHideDuration={3000}
            onClose={handleCloseSnackBar}
            key={vertical + horizontal}
          >
            <MuiAlert
              elevation={6}
              variant="filled"
              onClose={handleCloseSnackBar}
              severity={snackBarstate.type}
            >
              {snackBarstate.message}
            </MuiAlert>
          </Snackbar>
        </Container>
      </Grid>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        onBackdropClick={handleClose}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFF",
            width: "70vw",
            height: "70vh",
            padding: "20px",
            position: "relative",
          }}
        >
          <ImageCrop onProfileChange={onSelectlogo} handleClose={handleClose} />
        </div>
      </Modal>
    </Grid>
  );
}
